// The API's verdict on the exact credential still in the store ends the
// session silently, whatever the credential's claims say (1248h536z0k): the
// gateway's authorizer rejects it (expired, malformed, wrongly signed) with
// {"message":"Unauthorized"}, or get-customer-data reports the customer
// deleted. get-customer-data also answers 401 to its own failures, with a
// different body; those say nothing about the credential and keep the session,
// like a 401 for an older credential that was renewed meanwhile and any other
// failure (offline, timeout, 5xx).
export function isCurrentRejectedSession(
  requestToken: string,
  currentToken: string,
  error: { status?: number; error?: any },
): boolean {
  if (!requestToken || requestToken !== currentToken || error?.status !== 401) {
    return false;
  }
  const body = error.error;
  return !!body && typeof body === "object" &&
    (body.message === "Unauthorized" || body.comment_id === "deleted_customer");
}

// Every credential the API can accept is a compact JWT: three base64
// segments. Anything else can never be valid, and some of it never even
// reaches the API (a browser refuses to send a header with, say, Greek
// letters), so no verdict would ever come and the startup spinner would stay.
// Such a current credential ends the session silently, whatever the failure
// (1248h536z0k). Both base64 alphabets are allowed on purpose.
const COMPACT_JWT = /^[A-Za-z0-9_\-+/=]+\.[A-Za-z0-9_\-+/=]+\.[A-Za-z0-9_\-+/=]+$/;

export function isUnusableCurrentCredential(
  requestToken: string,
  currentToken: string,
): boolean {
  return !!requestToken && requestToken === currentToken &&
    !COMPACT_JWT.test(requestToken);
}

export class SessionRecoveryCheck {
  private token: string | null = null;
  private startedAt = -Infinity;
  private pending = false;
  private generation = 0;

  begin(token: string, now = Date.now()): (() => void) | null {
    if (!token || (token === this.token && (
      this.pending || (now >= this.startedAt && now - this.startedAt < 60000)
    ))) {
      return null;
    }
    this.token = token;
    this.startedAt = now;
    this.pending = true;
    const generation = ++this.generation;
    return () => {
      if (generation === this.generation) {
        this.pending = false;
      }
    };
  }
}
